import Layers from "slotworks/graphics/layers/layers";
import AbstractSliderControl from "slotworks/smart-ui/controls/abstract/abstract-slider-control";
import { Control } from "slotworks/smart-ui/controls/control";
import ControlOptions from "slotworks/smart-ui/options/control-options";
import HeadlessSmartUIGroup from "slotworks/smart-ui/smart-ui-group";
import { formatMoneyAsCurrency } from "slotworks/utils/string-formatters";

export default class TotalWinLossLimitSliderControl extends AbstractSliderControl implements Control {

    public setup(name: string, layer: Layers, assetName: string, assetNames: string[], smartUIGroup: HeadlessSmartUIGroup) {
        super.setup(name, layer, assetName, assetNames, smartUIGroup);

        this.formatFunction = formatMoneyAsCurrency;

        this.sliderComponent.onChange.add(this.onChangeHandler);
        this.sliderComponent.onInput.add(this.onChangeHandler);
    }

    public updateOptions(options: ControlOptions) {
        super.updateOptions(options);

        if (!options.totalWinLimit.values.length) {
            this.setVisibleTotalWinLossLimit(false);
        }

        if (options.totalWinLimit.values.length > 0 &&
            options.totalWinLimit.values[0] !== 0) {
                options.totalWinLimit.values.unshift(0);
        }

        this.setupData(options.totalWinLimit.values, options.totalWinLimit.currentValue);
    }

    protected onChangeHandler = (value: number) => {
        const options = new ControlOptions();
        options.totalWinLimit = this.options.totalWinLimit.clone();
        options.totalWinLimit.setCurrentIndex(value);

        this.setValueLabel(options.totalWinLimit.currentValue);

        this.onChange.dispatch(options);
    }

    private setVisibleTotalWinLossLimit(visible: boolean) {
        this.setVisible(visible);
        this.setVisibleValue(visible);
    }
}
